import React from "react";
import $ from "$";
import { Form, TreeZ } from "antd";
import classNames from "classnames";
import isEqual from "lodash/isEqual";
import isFunction from "lodash/isFunction";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import uniq from "lodash/uniq";
import WeaLocaleProvider from "../../wea-locale-provider";
import { getPageSize } from "../../wea-browser/coms/util";
import { formCb, defaultProps, defaultState } from "./propType";
import * as formmatData from "./formatData";
import * as getAssociative from "./getAssociative";
import * as getData from "./getData";
import * as getModal from "./getModal";
import * as getModalContent from "./getModalContent";
import * as getModalFooter from "./getModalFooter";
import * as getParams from "./getParams";
import * as getSearch from "./getSearch";
import * as getTransformLeft from "./getTransformLeft";
import * as onDataClick from "./onDataClick";

const { getLabel } = WeaLocaleProvider;

class WeaBrowser extends React.Component {
  static defaultProps = {
    ...defaultProps,
    title: getLabel(24986, "标题") // 浏览框标题
  };
  state = defaultState;
  constructor(props) {
    super(props);
    const functions = [
      formmatData,
      getAssociative,
      getData,
      getModal,
      getModalContent,
      getModalFooter,
      getParams,
      getSearch,
      getTransformLeft,
      onDataClick
    ];
    functions.map(funcs => {
      Object.keys(funcs).forEach(f => {
        if (typeof funcs[f] === "function") {
          this[f] = funcs[f].bind(this);
        }
      });
    });
    const { searchAdFormCallbackKey: key } = props;
    if (key && !formCb[key]) {
      formCb[key] = this.onFieldsChange;
    }
    const state = {
      isAccount: false, // 有无账号
      quickSearch: props.quickSearchName || "",
      pageSize: Number(props.pageSize > 0 ? props.pageSize : getPageSize(props))
    };
    TreeZ.loadZTree();
    this.updateState(props, state);
  }
  componentDidMount() {
    this.setMinWidth();
    this.updateState();
    if (!isEmpty(this.props.appendDatas)) {
      this.appendSearchValues(this.props.appendDatas, true);
    }
    this.props.initFunc && this.props.initFunc(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setMinWidth();
    if ("value" in nextProps && isEmpty(nextProps.value)) {
      this.associative && this.associative.clear && this.associative.clear();
    }
    if (
      "appendDatas" in nextProps &&
      !isEqual(this.props.appendDatas, nextProps.appendDatas) &&
      nextProps.appendDatas.length > 0
    ) {
      this.appendSearchValues(nextProps.appendDatas, true);
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas) &&
      !nextProps.replaceNotCtrl
    ) {
      if (isEmpty(nextProps.replaceDatas)) {
        this.associative && this.associative.clear && this.associative.clear();
      }
    }
    this.updateState(nextProps);
  }
  componentWillUnmount() {
    const { searchAdFormCallbackKey: key } = this.props;
    if (key && formCb[key]) {
      delete formCb[key];
    }
  }
  setMinWidth() {
    if (this.props.resize && this.refs.weaBrowser) {
      let dom = $(this.refs.weaBrowser);
      const browserWidth = 210;
      const interval = setInterval(() => {
        let width = dom.parent().outerWidth();
        if (width > 0) {
          if (width < 112) width = 112;
          dom.css("max-width", width);
          // 明细表单特殊处理
          let minWidth = browserWidth;
          if (width < browserWidth) {
            minWidth = width;
          }
          if (this.props.isDetail == 1) minWidth = width;
          dom
            .find(".wea-associative-search")
            .filter(":not(.wea-field-readonly)")
            .css("min-width", minWidth - 32)
            .css("margin-right", 12);
          dom.css("visibility", "visible");
          dom = null;
          clearInterval(interval);
        }
      }, 10);
    }
  }
  updateState = (props, state = {}) => {
    const newState = { ...state };
    const data = this.getDataOfProps(props);
    if (data !== undefined && !isEqual(data, this.state.data)) {
      newState.data = data;
    }
    this.setState(newState);
  };
  onChange = (newData, closeModal = true) => {
    /**
     * 处理所有的数据返回的入口
     * newData：返回的数据
     * closeModal：是否关闭dialog框
     * 返回由onChange返回数据
     * this.state.data为associative中的数据，也是下次打开浏览框的初始数据
     */
    const { onChange } = this.props;
    const { inputId, inputName } = this.state;
    let ids = [];
    const names = [];
    const data = newData
      .filter(item => {
        if (this.isCrm()) {
          if (item.type == "all") return true;
          // 过滤空数据分组
          if (item.type != "resource" && isEmpty(item.users)) return false;
        }
        return true;
      })
      .map(item => {
        const id = item[inputId] || item.id || "";
        const name =
          item.orgWholePathspan ||
          item[inputName] ||
          item.name ||
          item.lastname ||
          "";
        if (item.type == "all") {
          ids = [item.ids];
        } else if (item.users) {
          ids = ids.concat(item.users.map(i => i[inputId] || i.id));
        } else {
          ids.push(id);
        }
        names.push(name);
        return { ...item, id, name };
      });
    this.setState({ data });
    isFunction(onChange) && onChange(`${ids}`, `${names}`, data);
    closeModal && this.closeModal();
  };
  onSearch = (params, activeKey) => {
    /**
     * 处理所有的数据请求的入口，包括初始化数据、tab跳转、搜索、切换维度或是刷新数据等，各种情况根据activeKey来标识
     * params：请求参数
     * activeKey 需要跳转到的tab页
     * - 若activeKey为空，activeKey=this.getDefaultActiveKey(false)，activeKey为isSearch指定的tab；
     * - 初始时activeKey=this.getDefaultActiveKey(true)，activeKey为selected指定的默认tab
     */
    if (this.isCrm()) {
      activeKey = activeKey || "";
    } else {
      activeKey = activeKey || this.getDefaultActiveKey(false);
    }
    this.setState(
      {
        activeKey
      },
      () => {
        this.getData(
          this.getSearchParams({
            ...this.getHrmParams(activeKey, this.state.companyId),
            ...params
          })
        );
        this.weaSrcoll && this.weaSrcoll.scrollerToTop();
      }
    );
  };
  onFieldsChange = (props, fields) => {
    const quickSearch = this.state.quickSearch || "name";
    const newState = {};
    if (fields[quickSearch]) {
      const inputValue = fields[quickSearch].value;
      if (isString(inputValue)) {
        newState.inputValue = inputValue;
      }
    }
    if (fields.date2during) {
      const date2during = fields.date2during.value;
      newState.date2during = date2during;
    }
    this.setState(newState);
  };
  count(selectedData = [], rNum = false) {
    const { inputId } = this.state;
    let count = 0;
    let ids = [];
    selectedData.forEach(item => {
      if (item.users) {
        ids = ids.concat(item.users.map(d => d[inputId]));
      } else {
        ids.push(item[inputId]);
      }
    });
    count += uniq(ids).length;
    if (rNum) return count;
    return count > 0 ? `(${count})` : "";
  }
  isCrm = () => {
    const { type = 1 } = this.props;
    return type == "1" || type == "17";
  };
  getDataOfProps = props => {
    const { isSingle, valueObj, replaceDatas, value, valueSpan } =
      props || this.props;
    let data = [];
    if (valueObj !== undefined || replaceDatas !== undefined) {
      try {
        data = (valueObj || replaceDatas || []).filter(item => item && item.id);
      } catch (e) {
        /* eslint no-console: 0 */
        console && console.warn("浏览按钮脏数据: ", e);
        data = [];
      }
      if (this.isCrm()) {
        data = this.replaceSearchValues(data);
      }
      return data;
    }
    if (value !== undefined && isSingle) {
      if (value) {
        if (this.isCrm()) {
          data = [{ id: value, name: valueSpan }];
        } else {
          let name = "";
          if (!isEmpty(replaceDatas) && replaceDatas[0]) {
            name = replaceDatas[0].orgWholePathspan || replaceDatas[0].name;
          }
          data = [{ id: value, name: valueSpan || name }];
        }
      } else {
        data = [];
      }
      return data;
    }
    return undefined;
  };
  render() {
    const {
      className,
      customized,
      fieldName,
      viewAttr,
      style,
      extraElement
    } = this.props;
    const cls = classNames("wea-browser", className, {
      customized,
      "wea-field": /^field/.test(fieldName),
      "wea-field-readonly": viewAttr == "1"
    });
    const associative = this.getAssociative();
    const modal = this.getModal();
    return (
      <div className={cls} style={style} ref="weaBrowser">
        {associative}
        {extraElement}
        {modal}
      </div>
    );
  }
}
export default Form.create({
  onFieldsChange(props, fields) {
    const { searchAdFormCallbackKey: key } = props;
    if (key && formCb[key]) {
      formCb[key](props, fields);
    }
  }
})(WeaBrowser);



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/index.js